import React, { useEffect, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import Popupform from '../../Popupform/Popupform';
import axios from 'axios';
import config from '../../../config/config';
import Boucherpopup from '../../Popupform/Boucherpopup';


const Innerpagetopstudy = () => {

    const statename = useParams();
    console.log(statename)

    const [tableData, setTableData] = useState([]);


    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/get_collegespage/${statename.state}`,
                );
                console.log("response", response.data.collegePagesByState)
                const fetchedData = response.data.collegePagesByState || [];
                setTableData(fetchedData);
                console.log("fetchedData", fetchedData); // Log for debugging
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };

        fetchCollegeData();
    }, []);

    const [showPopup, setShowPopup] = useState(false);

    const handleOpenPopup = () => setShowPopup(true);
    const handleClosePopup = () => setShowPopup(false);




    // Download boucher 

    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    const handleOpenBoucherPopup = () => setShowBoucherPopup(true);
    const handleCloseBoucherPopup = () => setShowBoucherPopup(false);



    return (
        <div className="bg-gray-50 min-h-screen pb-20">
            {/* Banner Section */}
            <div className="bg-brand-dark text-white py-16 text-center shadow-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-brand-orange opacity-10"></div>
                <div className="container mx-auto px-4 relative z-10">
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">
                        Explore Best Study Destinations in <span className="text-brand-orange">{statename.state}</span>
                    </h2>
                    <p className="text-gray-300 max-w-2xl mx-auto text-lg leading-relaxed">
                        Looking for the perfect city to pursue your dreams? Explore top study destinations known for prestigious universities, world-class faculty, and excellent career opportunities.
                    </p>
                </div>
            </div>

            {/* Content Section */}
            <div className="container mx-auto px-4 mt-12">
                <div className="bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden">
                    {/* Desktop Header */}
                    <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-wider bg-gray-50">
                        <div className="col-span-1 text-center">Rank</div>
                        <div className="col-span-5">Colleges</div>
                        <div className="col-span-2">Course Fees</div>
                        <div className="col-span-2">Placement</div>
                        <div className="col-span-2">Eligibility</div>
                    </div>

                    {/* Table Rows */}
                    {tableData.length > 0 ? (
                        tableData.map((item, index) => (
                            <React.Fragment key={index}>
                                {/* Mobile Card View */}
                                <div className="md:hidden bg-white border-b border-gray-100 last:border-0 p-5 relative">
                                    <div className="flex items-start gap-4 mb-4">
                                        <div className="absolute top-0 left-0 bg-yellow-400 text-white text-[10px] font-bold px-3 py-1 rounded-br-lg shadow-sm z-10">
                                            #{item.rank}
                                        </div>

                                        <div className="mt-6 flex-1">
                                            <NavLink
                                                to={`/college/${item._id}`}
                                                className="font-bold text-gray-900 leading-tight text-lg block mb-1 hover:text-brand-orange no-underline"
                                            >
                                                {item.collegeName}
                                            </NavLink>
                                            <div className="flex items-center text-xs text-gray-500 mb-2">
                                                <i className="fa fa-map-marker mr-1"></i> {item.city}
                                            </div>
                                            <p className="text-xs text-gray-400 mb-3 line-clamp-2">{item.subheading}</p>
                                        </div>
                                    </div>

                                    {/* Additional Info Grid */}
                                    <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-3 mb-4">
                                        <div>
                                            <p className="text-[10px] text-gray-400 uppercase font-bold">Fees</p>
                                            <p className="text-sm font-bold text-gray-800">₹{item.fee}</p>
                                        </div>
                                        <div>
                                            <p className="text-[10px] text-gray-400 uppercase font-bold">Avg Placement</p>
                                            <p className="text-sm font-bold text-green-600">₹{item.placementavg}</p>
                                        </div>
                                        <div className="col-span-2 border-t border-gray-50 pt-2 mt-2">
                                            <p className="text-[10px] text-gray-400 uppercase font-bold">Eligibility</p>
                                            <p className="text-xs text-gray-600">{item.eligibility}</p>
                                        </div>
                                    </div>

                                    {/* Actions */}
                                    <div className="flex flex-col sm:flex-row gap-2">
                                        <button
                                            onClick={handleOpenPopup}
                                            className="flex-1 bg-brand-orange text-white text-sm font-bold py-3 rounded-lg hover:bg-orange-600 transition flex items-center justify-center border-0"
                                        >
                                            Apply Now
                                        </button>
                                        <button
                                            onClick={handleOpenBoucherPopup}
                                            className="flex-1 bg-gray-50 text-gray-700 border border-gray-200 text-sm font-bold py-3 rounded-lg hover:bg-gray-100 transition flex items-center justify-center"
                                        >
                                            Download Brochure
                                        </button>
                                    </div>
                                </div>

                                {/* Desktop Row View */}
                                <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 hover:bg-orange-50/30 transition items-center group">
                                    <div className="col-span-1 text-center font-bold text-brand-orange text-lg">
                                        #{item.rank}
                                    </div>
                                    <div className="col-span-5">
                                        <NavLink to={`/college/${item._id}`} className="text-lg font-bold text-gray-800 hover:text-brand-orange transition-colors block mb-1 no-underline">
                                            {item.collegeName}
                                        </NavLink>
                                        <div className="text-sm text-gray-500 mb-1">{item.city}</div>
                                        <div className="text-xs text-gray-400 mb-3">{item.subheading}</div>
                                        <div className="flex gap-3">
                                            <button onClick={handleOpenPopup} className="text-xs font-bold text-white bg-brand-orange px-3 py-1.5 rounded-full hover:bg-orange-700 transition shadow-sm border-0">
                                                Apply Now →
                                            </button>
                                            <button onClick={handleOpenBoucherPopup} className="text-xs font-bold text-brand-orange border border-brand-orange px-3 py-1.5 rounded-full hover:bg-orange-50 transition">
                                                Download Brochure
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-span-2 font-bold text-green-600">
                                        ₹{item.fee}
                                    </div>
                                    <div className="col-span-2">
                                        <div className="mb-1">
                                            <span className="font-bold text-gray-800">₹{item.placementavg}</span>
                                            <span className="text-xs text-gray-500 ml-1">Avg</span>
                                        </div>
                                        <div>
                                            <span className="font-bold text-gray-800">₹{item.placementhig}</span>
                                            <span className="text-xs text-gray-500 ml-1">High</span>
                                        </div>
                                    </div>
                                    <div className="col-span-2 text-sm text-gray-600">
                                        {item.eligibility}
                                    </div>
                                </div>
                            </React.Fragment>
                        ))
                    ) : (
                        <div className="p-12 text-center text-gray-500">
                            No colleges found in {statename.state}.
                        </div>
                    )}
                </div>
            </div>

            {/* Popup Modal */}
            {showPopup && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl p-1 relative w-full max-w-md shadow-2xl">
                        <button className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition" onClick={handleClosePopup}>
                            &times;
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}

            {/* Boucher Popup */}
            {showBoucherPopup && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl p-1 relative w-full max-w-md shadow-2xl">
                        <button className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition" onClick={handleCloseBoucherPopup}>
                            &times;
                        </button>
                        <Boucherpopup />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Innerpagetopstudy
